import { SvgIcon } from '@material-ui/core'

export default function StatsIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 25 24" fill="none" {...props}>
            <path
                d="M22.0583 10.0018C21.6078 6.38151 18.7383 3.51202 15.118 3.06149C14.57 2.99329 14.12 3.44756 14.12 3.99984V10.4998C14.12 10.776 14.3439 10.9998 14.62 10.9998H21.12C21.6723 10.9998 22.1266 10.5499 22.0583 10.0018Z"
                fill="currentColor"
            />
            <path
                d="M12.12 4.49985C7.42557 4.49985 3.62 8.30543 3.62 12.9998C3.62 17.6943 7.42557 21.4998 12.12 21.4998C16.8144 21.4998 20.62 17.6943 20.62 12.9998C20.62 12.7237 20.3961 12.4998 20.12 12.4998H13.12C12.8439 12.4998 12.62 12.276 12.62 11.9998V4.99985C12.62 4.72371 12.3961 4.49985 12.12 4.49985Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
